// Import React.
import React from "react";



// Export the reusable footer component.
export const LandingFooter = () => {


    // Get the current year for the copyright message.
    const currentYear = new Date().getFullYear();



    // Render the footer.
    return (

        // Render the main site footer.
        <footer className="landing-footer">

            {/* Constrain the footer content to the main site width. */}
            <div className="footer__inner">

                {/* Render the legal navigation links. */}
                <nav
                    className="footer__navigation"
                    aria-label="Legal navigation"
                >

                    {/* Link to the privacy policy. */}
                    <a
                        className="footer__link"
                        href="/privacy-policy"
                    >
                        Privacy Policy
                    </a>

                </nav>

                {/* Render the copyright information. */}
                <p className="footer__copyright">
                    © StrichSuite {currentYear} - A Pantheon Business Group Service. All Rights Reserved.
                </p>

            </div>

        </footer>

    );

};